<template>
  <div v-if="informationList.length" class="wrap">
    <div>
      <tw-table-system :schemas="schemas" :height="269" :nopager="true" :items="informationList" @row-click="rowClick" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { NEWS_TYPE_VARIABLES, PRIORITY_FLG } from 'lib-tw-common';
import TwTableSystem from '@/components/organisms/TwTableSystem';
import schemas from '@/dictionaries/dashBoardInformationSchema.json';

export default {
  name: 'TwDashBoardInformation',
  components: {
    TwTableSystem
  },
  data() {
    return {
      schemas: schemas,
      PRIORITY_FLG,
    }
  },
  computed: {
    informationList() {
      return this.$store.state.newsList ? this.$store.state.newsList : [];
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch('GET_NEWS_LIST');
    },
    showDetail(message) {
      this.$router.push({
        name: 'NewsDetail',
        params: { informationId: message.informationId },
      });
    },
    // newsTypeの表示名を取得します
    getNewsType(type) {
      return _.get(_.find( NEWS_TYPE_VARIABLES, {code: type}), 'label');
    },
    rowClick(row) {
      if (row.informationId) {
        this.$router.push({
          name: 'NewsDetail',
          params: { informationId: row.informationId },
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .wrap {
    margin: 20px 10px;
  }
</style>
